import { isLocal } from 'common/utils';

export const initBrowserMsw = async () => {
  if (isLocal() && import.meta.env.VITE_ENABLE_BROWSER_MSW === 'true') {
    const { worker } = await import('./browser');
    await worker.start({
      onUnhandledRequest: 'bypass',
    });
  }
};
